<template>
  <div
    :id="id"
    :class="['check', { 'check--active' : checked, 'check--clickable' : hasLink }, getTheme]"
    tabindex="0"
    @click="onClick"
    @keydown.enter="onClick"
  >
    <div class="check__circle" />
    <div
      v-if="!hasLink"
      :id="id + '-link'"
      class="check__text"
      @click="onClick"
    >
      {{ item.Text }}
    </div>
    <a
      v-else
      :id="id + '-text'"
      class="check__text check__text-link"
      :href="item.Url"
      target="_blank"
      @keyup.enter="onEnter"
    >
      {{ item.Text }}
    </a>
  </div>
</template>

<script>
import emitter from 'tiny-emitter/instance'

export default {
  name: 'nt-form-check',
  props: {
    id: {
      type: String,
      default: 'check'
    },
    item: {
      type: Object,
      required: true,
      validator(val) {
        return Object.hasOwnProperty.call(val, 'Text')
               && Object.hasOwnProperty.call(val, 'Value')
      }
    },
    theme: {
      type: String,
      default: 'default'
    },
  },
  data() {
    return {
      checked: false
    }
  },
  computed: {
    getTheme() {
      return `check--${this.theme}`
    },
    hasLink() {
      return !!this.item.Url
    }
  },
  methods: {
    onEnter(event) {
      event.stopPropagation()
      window.open(this.item.Url, '_blank')
    },
    onClick() {
      this.checked = !this.checked

      emitter.emit('onSelectFormCheck', {
        Text: this.item.Text,
        Value: this.item.Value,
        Checked: this.checked
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .check {
    $container: &;
    display: flex;
    align-items: flex-start;

    &:hover {
      cursor: pointer;
    }

    &__circle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.125rem;
      height: 1.125rem;
      min-width: 1.125rem;
      min-height: 1.125rem;
      padding: 0.125rem;
      margin-right: 0.625rem;
      border: 0.125rem solid $neutral-04;
    }

    &__text {
      font-size: 1rem;
      line-height: 1rem;
      letter-spacing: -1px;
      color: $neutral-03;
      text-decoration: none;
    }

    &--clickable {
      #{$container}__text {
        &:hover {
          text-decoration: underline;
        }
      }
    }

    &--active {
      #{$container}__circle {
        &::before {
          content: '';
          width: 100%;
          height: 100%;
          background: $blue-04;
        }
      }
    }

    &--small {
      #{$container}__circle {
        min-width: 1rem;
        min-height: 1rem;
        width: 1rem;
        height: 1rem;
      }

      #{$container}__text {
        font-size: 1rem;
        line-height: 1rem;
      }
    }
  }
</style>
